import React from "react";
import { useSelector } from "react-redux";
import { FORM_STATES } from "../orderCreationSlice";

export const FormGuard = ({ children, router, location }) => {
  const formState = useSelector(s => s.slices.orderCreation.formState);

  if (
    formState === FORM_STATES.NOT_STARTED &&
    location?.pathname !== "/startups/orders/new"
  ) {
    router?.push("/startups/orders/new");
  }

  if (
    location?.pathname === "/startups/orders/new" &&
    formState !== FORM_STATES.NOT_STARTED
  ) {
    router?.push("/startups/orders/new/store");
  }

  if (
    location?.pathname !== "/startups/orders/new/success" &&
    formState === FORM_STATES.SUCCESS
  ) {
    router?.push("/startups/orders/new/success");
  }

  return <>{children}</>;
};
